import { authRoles } from "../../../auth/authRoles";
import EditHotel from "./EditHotel";
import Hotel from "./Hotel";
import TambahHotel from "./TambahHotel";

const hotelRoutes = [
  {
    path: "/hotel/edit/:id",
    exact: true,
    component: EditHotel,
    auth: authRoles.all,
  },
  {
    path: "/hotel/tambah",
    exact: true,
    component: TambahHotel,
    auth: authRoles.all,
  },
  {
    path: "/hotel",
    exact: true,
    component: Hotel,
    auth: authRoles.all,
  },
];

export default hotelRoutes;
